// CTA.js
import React from 'react';
import { Box, Typography, Stack, IconButton } from '@mui/material';
import CallIcon from '@mui/icons-material/Call';

const CTA = () => {
  const ORANGE = '#ff7f00';

  // Images from the template
  const rightBg = 'https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/image_03.jpg';
  const badge = 'https://qleen.bold-themes.com/demo-01/wp-content/uploads/sites/2/2025/07/team_01.png';

  return (
    <Box id="cta" sx={{ py: { xs: 6, md: 8 }, bgcolor: '#fff' }}>
      <Box sx={{ maxWidth: 1400, mx: 'auto', px: 2 }}>
        <Box
          sx={{
            position: 'relative',
            borderRadius: { xs: 6, md: 10 },
              overflow: 'visible',
            minHeight: { xs: 220, md: 280 },
            bgcolor: ORANGE
          }}
        >
          {/* Right photo */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
              height: '100%',
              width: { xs: '52%', md: '52%' },
              display: { xs: 'none', sm: 'block' },
              backgroundImage: `url(${rightBg})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          />

          {/* dark fade at the seam for nicer blend */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              right: { xs: 0, sm: '48%' },
              height: '100%',
              width: { xs: 0, sm: 90 },
              display: { xs: 'none', sm: 'block' },
              background: 'linear-gradient(90deg, rgba(255,127,0,1) 0%, rgba(255,127,0,0) 100%)'
            }}
          />

          {/* Badge */}
          <Box
            component="img"
            src={badge}
            alt="2024 award badge"
            sx={{
              display: { xs: 'none', md: 'block' },
              position: 'absolute',
              top: -100,
              right: 302,
              width: '30%',
              height: 'auto',
              zIndex: 2
            }}
          />

          {/* Content */}
          <Box
            sx={{
              position: 'relative',
              zIndex: 2,
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              px: { xs: 3, md: 7 },
              py: { xs: 5, md: 6 },
              width: { xs: '100%', sm: '56%', md: '54%' }
            }}
          >
            <Box>
              <Typography
                sx={{
                  color: '#fff',
                  fontWeight: 900,
                  letterSpacing: '-0.03em',
                  fontSize: { xs: 30, md: 44 },
                  lineHeight: 1.05
                }}
              >
               How Can We help <br />
                You Today?
              </Typography>

              <Typography
                sx={{
                  mt: 2.5,
                  color: 'rgba(255,255,255,0.95)',
                  fontWeight: 800,
                  fontSize: { xs: 16, md: 18 }
                }}
              >
                Book Your Service Now
              </Typography>

              <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mt: 4 }}>
                <IconButton
                  component="a"
                  href="tel:8442429464"
                  aria-label="Call us"
                  sx={{
                    width: 44,
                    height: 44,
                    bgcolor: '#fff',
                    color: ORANGE,
                    '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' }
                  }}
                >
                  <CallIcon sx={{ fontSize: 20 }} />
                </IconButton>

                <Typography
                  component="a"
                  href="tel:8442429464"
                  sx={{
                    color: '#fff',
                    textDecoration: 'none',
                    fontWeight: 900
                  }}
                >
                  Call us: +1 (888) 835-2473
                </Typography>
              </Stack>
            </Box>
          </Box>

          {/* Mobile image (below text look) */}
          <Box
            sx={{
              display: { xs: 'block', sm: 'none' },
              height: 180,
              backgroundImage: `url(${rightBg})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CTA;
